import React, { ForwardedRef } from "react";
import clsx from "clsx";

import { FieldGroupProps } from "./FieldGroup.types";
import { useStyles } from "./FieldGroup.styles";
import { FormHelperText } from "..";

const FieldGroup = React.forwardRef(function FieldGroup(
  props: FieldGroupProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const {
    children,
    contentRef,
    error,
    helperText,
    prefixWidth = 48,
    prefixWidthUnit = "px",
    size,
    showHelperTextMargin,
    ...other
  } = props;

  const classes = useStyles(props);

  const renderChildren = () => {
    const arr = React.Children.toArray(children);

    return arr.map((child: any, index: number) => {
      const flex =
        index === 0 ? `0 0 ${prefixWidth}${prefixWidthUnit}` : undefined;
      const field = React.cloneElement(child, { error, size });
      return (
        <div key={index} className={classes.item} style={{ flex }}>
          {field}
        </div>
      );
    });
  };

  const rootClassName = clsx(classes.root, {
    [classes.helperTextMargin]: !helperText && showHelperTextMargin,
  });

  return (
    <div {...other} className={rootClassName} ref={ref}>
      <div className={classes.items} ref={contentRef}>
        {renderChildren()}
      </div>
      {helperText && (
        <FormHelperText error={error} variant="outlined">
          {helperText}
        </FormHelperText>
      )}
    </div>
  );
});

export default FieldGroup;
